import Loadable from "react-loadable";
import Loading from "../components/Loading";

export const Login = Loadable({
    loader: () => import("../scenes/Login"),
    loading: Loading
});

export const FreshOrders = Loadable({
    loader: () => import("../scenes/FreshOrders"),
    loading: Loading
});

export const OldFreshOrders = Loadable({
    loader: () => import("../scenes/OldFreshOrders"),
    loading: Loading
});

export const OrderIn = Loadable({
    loader: () => import("../scenes/OrderIn"),
    loading: Loading
});

export const Tables = Loadable({
    loader: () => import("../scenes/Tables"),
    loading: Loading
});

export const CategoryWrapper = Loadable({
    loader: () => import("../scenes/CategoryWrapper"),
    loading: Loading
});

export const Categories = Loadable({
    loader: () => import("../scenes/Categories"),
    loading: Loading
});

export const CategoryIn = Loadable({
    loader: () => import("../scenes/CategoryIn"),
    loading: Loading
});

export const ProductIn = Loadable({
    loader: () => import("../scenes/ProductIn"),
    loading: Loading
});

export const Courier = Loadable({
    loader: () => import("../scenes/Courier"),
    loading: Loading
});

export const Payment = Loadable({
    loader: () => import("../scenes/Payment"),
    loading: Loading
});

export const Phoneorder = Loadable({
    loader: () => import("../scenes/PhoneOrder"),
    loading: Loading
});

export const Settings = Loadable({
    loader: () => import("../scenes/Settings"),
    loading: Loading
});

export const Kitchen = Loadable({
    loader: () => import("../scenes/Kitchen"),
    loading: Loading
});

export const OldKitchen = Loadable({
    loader: () => import("../scenes/OldKitchen"),
    loading: Loading
});

export const Statistics = Loadable({
    loader: () => import("../scenes/Statistics"),
    loading: Loading
});

export const DetailCourrier = Loadable({
    loader: () => import("../scenes/DetailCourrier"),
    loading: Loading
});

export const Invoices = Loadable({
    loader: () => import("../scenes/Invoices"),
    loading: Loading
});

export const Knowledge = Loadable({
    loader: () => import("../scenes/Knowledge"),
    loading: Loading
});

export const Admin = Loadable({
    loader: () => import("../scenes/Admin"),
    loading: Loading
});

export const Denied = Loadable({
    loader: () => import("../scenes/Denied"),
    loading: Loading
});

export const Logout = Loadable({
    loader: () => import("../components/Logout"),
    loading: Loading
});

export const PrintFull = Loadable({
    loader: () => import("../scenes/Print/Full"),
    loading: Loading
});

export const PrintKitchen = Loadable({
    loader: () => import("../scenes/Print/Kitchen"),
    loading: Loading
});

export const PrintDailyClose = Loadable({
    loader: () => import("../scenes/Print/DailyClose"),
    loading: Loading
});

export const PrintCourierSummery = Loadable({
    loader: () => import("../scenes/Print/CourierSummery"),
    loading: Loading
});

export const PrintCourierClose = Loadable({
    loader: () => import("../scenes/Print/CourierClose"),
    loading: Loading
});

export const LCTCourier = Loadable({
    loader: () => import("../scenes/LCTCourier"),
    loading: Loading
});



// WEBPACK FOOTER //
// ./src/routes/Components.js